import { Option } from '@/modules/entity/utils/option.ts';

export const countryOptions: Option<string>[] = [
  {
    label: 'Australia',
    value: 'AUS',
  },
  {
    label: 'New Zealand',
    value: 'NZL',
  },
  {
    label: 'United States of America',
    value: 'USA',
  },
  {
    label: 'China',
    value: 'CHN',
  },
  {
    label: 'Afghanistan',
    value: 'AFG',
  },
  {
    label: 'Aland Islands',
    value: 'ALA',
  },
  {
    label: 'Albania',
    value: 'ALB',
  },
  {
    label: 'Algeria',
    value: 'DZA',
  },
  {
    label: 'American Samoa',
    value: 'ASM',
  },
  {
    label: 'Andorra',
    value: 'AND',
  },
  {
    label: 'Angola',
    value: 'AGO',
  },
  {
    label: 'Anguilla',
    value: 'AIA',
  },
  {
    label: 'Antarctica',
    value: 'ATA',
  },
  {
    label: 'Antigua and Barbuda',
    value: 'ATG',
  },
  {
    label: 'Argentina',
    value: 'ARG',
  },
  {
    label: 'Armenia',
    value: 'ARM',
  },
  {
    label: 'Aruba',
    value: 'ABW',
  },
  {
    label: 'Austria',
    value: 'AUT',
  },
  {
    label: 'Azerbaijan',
    value: 'AZE',
  },
  {
    label: 'Bahamas',
    value: 'BHS',
  },
  {
    label: 'Bahrain',
    value: 'BHR',
  },
  {
    label: 'Bangladesh',
    value: 'BGD',
  },
  {
    label: 'Barbados',
    value: 'BRB',
  },
  {
    label: 'Belarus',
    value: 'BLR',
  },
  {
    label: 'Belgium',
    value: 'BEL',
  },
  {
    label: 'Belize',
    value: 'BLZ',
  },
  {
    label: 'Benin',
    value: 'BEN',
  },
  {
    label: 'Bermuda',
    value: 'BMU',
  },
  {
    label: 'Bhutan',
    value: 'BTN',
  },
  {
    label: 'Bolivia',
    value: 'BOL',
  },
  {
    label: 'Bonaire, Sint Eustatius and Saba',
    value: 'BES',
  },
  {
    label: 'Bosnia and Herzegovina',
    value: 'BIH',
  },
  {
    label: 'Botswana',
    value: 'BWA',
  },
  {
    label: 'Bouvet Island',
    value: 'BVT',
  },
  {
    label: 'Brazil',
    value: 'BRA',
  },
  {
    label: 'British Indian Ocean Territory',
    value: 'IOT',
  },
  {
    label: 'United States Minor Outlying Islands',
    value: 'UMI',
  },
  {
    label: 'Virgin Islands (British)',
    value: 'VGB',
  },
  {
    label: 'Virgin Islands (U.S.)',
    value: 'VIR',
  },
  {
    label: 'Brunei Darussalam',
    value: 'BRN',
  },
  {
    label: 'Bulgaria',
    value: 'BGR',
  },
  {
    label: 'Burkina Faso',
    value: 'BFA',
  },
  {
    label: 'Burundi',
    value: 'BDI',
  },
  {
    label: 'Cambodia',
    value: 'KHM',
  },
  {
    label: 'Cameroon',
    value: 'CMR',
  },
  {
    label: 'Canada',
    value: 'CAN',
  },
  {
    label: 'Cabo Verde',
    value: 'CPV',
  },
  {
    label: 'Cayman Islands',
    value: 'CYM',
  },
  {
    label: 'Central African Republic',
    value: 'CAF',
  },
  {
    label: 'Chad',
    value: 'TCD',
  },
  {
    label: 'Chile',
    value: 'CHL',
  },
  {
    label: 'Christmas Island',
    value: 'CXR',
  },
  {
    label: 'Keeling Islands',
    value: 'CCK',
  },
  {
    label: 'Colombia',
    value: 'COL',
  },
  {
    label: 'Comoros',
    value: 'COM',
  },
  {
    label: 'Congo',
    value: 'COG',
  },
  {
    label: 'Congo, Democratic Republic',
    value: 'COD',
  },
  {
    label: 'Cook Islands',
    value: 'COK',
  },
  {
    label: 'Costa Rica',
    value: 'CRI',
  },
  {
    label: 'Croatia',
    value: 'HRV',
  },
  {
    label: 'Cuba',
    value: 'CUB',
  },
  {
    label: 'Curacao',
    value: 'CUW',
  },
  {
    label: 'Cyprus',
    value: 'CYP',
  },
  {
    label: 'Czech Republic',
    value: 'CZE',
  },
  {
    label: 'Denmark',
    value: 'DNK',
  },
  {
    label: 'Djibouti',
    value: 'DJI',
  },
  {
    label: 'Dominica',
    value: 'DMA',
  },
  {
    label: 'Dominican Republic',
    value: 'DOM',
  },
  {
    label: 'Ecuador',
    value: 'ECU',
  },
  {
    label: 'Egypt',
    value: 'EGY',
  },
  {
    label: 'El Salvador',
    value: 'SLV',
  },
  {
    label: 'Equatorial Guinea',
    value: 'GNQ',
  },
  {
    label: 'Eritrea',
    value: 'ERI',
  },
  {
    label: 'Estonia',
    value: 'EST',
  },
  {
    label: 'Ethiopia',
    value: 'ETH',
  },
  {
    label: 'Falkland Islands',
    value: 'FLK',
  },
  {
    label: 'Faroe Islands',
    value: 'FRO',
  },
  {
    label: 'Fiji',
    value: 'FJI',
  },
  {
    label: 'Finland',
    value: 'FIN',
  },
  {
    label: 'France',
    value: 'FRA',
  },
  {
    label: 'French Guiana',
    value: 'GUF',
  },
  {
    label: 'French Polynesia',
    value: 'PYF',
  },
  {
    label: 'French Southern Territories',
    value: 'ATF',
  },
  {
    label: 'Gabon',
    value: 'GAB',
  },
  {
    label: 'Gambia',
    value: 'GMB',
  },
  {
    label: 'Georgia',
    value: 'GEO',
  },
  {
    label: 'Germany',
    value: 'DEU',
  },
  {
    label: 'Ghana',
    value: 'GHA',
  },
  {
    label: 'Gibraltar',
    value: 'GIB',
  },
  {
    label: 'Greece',
    value: 'GRC',
  },
  {
    label: 'Greenland',
    value: 'GRL',
  },
  {
    label: 'Grenada',
    value: 'GRD',
  },
  {
    label: 'Guadeloupe',
    value: 'GLP',
  },
  {
    label: 'Guam',
    value: 'GUM',
  },
  {
    label: 'Guatemala',
    value: 'GTM',
  },
  {
    label: 'Guernsey',
    value: 'GGY',
  },
  {
    label: 'Guinea',
    value: 'GIN',
  },
  {
    label: 'Guinea-Bissau',
    value: 'GNB',
  },
  {
    label: 'Guyana',
    value: 'GUY',
  },
  {
    label: 'Haiti',
    value: 'HTI',
  },
  {
    label: 'Heard Island and McDonald Islands',
    value: 'HMD',
  },
  {
    label: 'Holy See',
    value: 'VAT',
  },
  {
    label: 'Honduras',
    value: 'HND',
  },
  {
    label: 'Hong Kong',
    value: 'HKG',
  },
  {
    label: 'Hungary',
    value: 'HUN',
  },
  {
    label: 'Iceland',
    value: 'ISL',
  },
  {
    label: 'India',
    value: 'IND',
  },
  {
    label: 'Indonesia',
    value: 'IDN',
  },
  {
    label: 'Ivory Coast',
    value: 'CIV',
  },
  {
    label: 'Iran',
    value: 'IRN',
  },
  {
    label: 'Iraq',
    value: 'IRQ',
  },
  {
    label: 'Ireland',
    value: 'IRL',
  },
  {
    label: 'Isle of Man',
    value: 'IMN',
  },
  {
    label: 'Israel',
    value: 'ISR',
  },
  {
    label: 'Italy',
    value: 'ITA',
  },
  {
    label: 'Jamaica',
    value: 'JAM',
  },
  {
    label: 'Japan',
    value: 'JPN',
  },
  {
    label: 'Jersey',
    value: 'JEY',
  },
  {
    label: 'Jordan',
    value: 'JOR',
  },
  {
    label: 'Kazakhstan',
    value: 'KAZ',
  },
  {
    label: 'Kenya',
    value: 'KEN',
  },
  {
    label: 'Kiribati',
    value: 'KIR',
  },
  {
    label: 'Kuwait',
    value: 'KWT',
  },
  {
    label: 'Kyrgyzstan',
    value: 'KGZ',
  },
  {
    label: 'Laos',
    value: 'LAO',
  },
  {
    label: 'Latvia',
    value: 'LVA',
  },
  {
    label: 'Lebanon',
    value: 'LBN',
  },
  {
    label: 'Lesotho',
    value: 'LSO',
  },
  {
    label: 'Liberia',
    value: 'LBR',
  },
  {
    label: 'Libya',
    value: 'LBY',
  },
  {
    label: 'Liechtenstein',
    value: 'LIE',
  },
  {
    label: 'Lithuania',
    value: 'LTU',
  },
  {
    label: 'Luxembourg',
    value: 'LUX',
  },
  {
    label: 'Macao',
    value: 'MAC',
  },
  {
    label: 'North Macedonia',
    value: 'MKD',
  },
  {
    label: 'Madagascar',
    value: 'MDG',
  },
  {
    label: 'Malawi',
    value: 'MWI',
  },
  {
    label: 'Malaysia',
    value: 'MYS',
  },
  {
    label: 'Maldives',
    value: 'MDV',
  },
  {
    label: 'Mali',
    value: 'MLI',
  },
  {
    label: 'Malta',
    value: 'MLT',
  },
  {
    label: 'Marshall Islands',
    value: 'MHL',
  },
  {
    label: 'Martinique',
    value: 'MTQ',
  },
  {
    label: 'Mauritania',
    value: 'MRT',
  },
  {
    label: 'Mauritius',
    value: 'MUS',
  },
  {
    label: 'Mayotte',
    value: 'MYT',
  },
  {
    label: 'Mexico',
    value: 'MEX',
  },
  {
    label: 'Micronesia',
    value: 'FSM',
  },
  {
    label: 'Moldova',
    value: 'MDA',
  },
  {
    label: 'Monaco',
    value: 'MCO',
  },
  {
    label: 'Mongolia',
    value: 'MNG',
  },
  {
    label: 'Montenegro',
    value: 'MNE',
  },
  {
    label: 'Montserrat',
    value: 'MSR',
  },
  {
    label: 'Morocco',
    value: 'MAR',
  },
  {
    label: 'Mozambique',
    value: 'MOZ',
  },
  {
    label: 'Myanmar',
    value: 'MMR',
  },
  {
    label: 'Namibia',
    value: 'NAM',
  },
  {
    label: 'Nauru',
    value: 'NRU',
  },
  {
    label: 'Nepal',
    value: 'NPL',
  },
  {
    label: 'Netherlands',
    value: 'NLD',
  },
  {
    label: 'New Caledonia',
    value: 'NCL',
  },
  {
    label: 'Nicaragua',
    value: 'NIC',
  },
  {
    label: 'Niger',
    value: 'NER',
  },
  {
    label: 'Nigeria',
    value: 'NGA',
  },
  {
    label: 'Niue',
    value: 'NIU',
  },
  {
    label: 'Norfolk Island',
    value: 'NFK',
  },
  {
    label: "Korea, Democratic People's Republic of",
    value: 'PRK',
  },
  {
    label: 'Northern Mariana Islands',
    value: 'MNP',
  },
  {
    label: 'Norway',
    value: 'NOR',
  },
  {
    label: 'Oman',
    value: 'OMN',
  },
  {
    label: 'Pakistan',
    value: 'PAK',
  },
  {
    label: 'Palau',
    value: 'PLW',
  },
  {
    label: 'Palestine, State of',
    value: 'PSE',
  },
  {
    label: 'Panama',
    value: 'PAN',
  },
  {
    label: 'Papua New Guinea',
    value: 'PNG',
  },
  {
    label: 'Paraguay',
    value: 'PRY',
  },
  {
    label: 'Peru',
    value: 'PER',
  },
  {
    label: 'Philippines',
    value: 'PHL',
  },
  {
    label: 'Pitcairn',
    value: 'PCN',
  },
  {
    label: 'Poland',
    value: 'POL',
  },
  {
    label: 'Portugal',
    value: 'PRT',
  },
  {
    label: 'Puerto Rico',
    value: 'PRI',
  },
  {
    label: 'Qatar',
    value: 'QAT',
  },
  {
    label: 'Republic of Kosovo',
    value: 'KOS',
  },
  {
    label: 'Réunion',
    value: 'REU',
  },
  {
    label: 'Romania',
    value: 'ROU',
  },
  {
    label: 'Russian Federation',
    value: 'RUS',
  },
  {
    label: 'Rwanda',
    value: 'RWA',
  },
  {
    label: 'Saint Barthélemy',
    value: 'BLM',
  },
  {
    label: 'Saint Helena, Ascension and Tristan da Cunha',
    value: 'SHN',
  },
  {
    label: 'Saint Kitts and Nevis',
    value: 'KNA',
  },
  {
    label: 'Saint Lucia',
    value: 'LCA',
  },
  {
    label: 'Saint Martin (French part)',
    value: 'MAF',
  },
  {
    label: 'Saint Pierre and Miquelon',
    value: 'SPM',
  },
  {
    label: 'Saint Vincent and the Grenadines',
    value: 'VCT',
  },
  {
    label: 'Samoa',
    value: 'WSM',
  },
  {
    label: 'San Marino',
    value: 'SMR',
  },
  {
    label: 'Sao Tome and Principe',
    value: 'STP',
  },
  {
    label: 'Saudi Arabia',
    value: 'SAU',
  },
  {
    label: 'Senegal',
    value: 'SEN',
  },
  {
    label: 'Serbia',
    value: 'SRB',
  },
  {
    label: 'Seychelles',
    value: 'SYC',
  },
  {
    label: 'Sierra Leone',
    value: 'SLE',
  },
  {
    label: 'Singapore',
    value: 'SGP',
  },
  {
    label: 'Sint Maarten (Dutch part)',
    value: 'SXM',
  },
  {
    label: 'Slovakia',
    value: 'SVK',
  },
  {
    label: 'Slovenia',
    value: 'SVN',
  },
  {
    label: 'Solomon Islands',
    value: 'SLB',
  },
  {
    label: 'Somalia',
    value: 'SOM',
  },
  {
    label: 'South Africa',
    value: 'ZAF',
  },
  {
    label: 'South Georgia and the South Sandwich Islands',
    value: 'SGS',
  },
  {
    label: 'Korea, Republic of',
    value: 'KOR',
  },
  {
    label: 'South Sudan',
    value: 'SSD',
  },
  {
    label: 'Spain',
    value: 'ESP',
  },
  {
    label: 'Sri Lanka',
    value: 'LKA',
  },
  {
    label: 'Sudan',
    value: 'SDN',
  },
  {
    label: 'Surilabel',
    value: 'SUR',
  },
  {
    label: 'Svalbard and Jan Mayen',
    value: 'SJM',
  },
  {
    label: 'Swaziland',
    value: 'SWZ',
  },
  {
    label: 'Sweden',
    value: 'SWE',
  },
  {
    label: 'Switzerland',
    value: 'CHE',
  },
  {
    label: 'Syria',
    value: 'SYR',
  },
  {
    label: 'Taiwan',
    value: 'TWN',
  },
  {
    label: 'Tajikistan',
    value: 'TJK',
  },
  {
    label: 'Tanzania',
    value: 'TZA',
  },
  {
    label: 'Thailand',
    value: 'THA',
  },
  {
    label: 'Timor-Leste',
    value: 'TLS',
  },
  {
    label: 'Togo',
    value: 'TGO',
  },
  {
    label: 'Tokelau',
    value: 'TKL',
  },
  {
    label: 'Tonga',
    value: 'TON',
  },
  {
    label: 'Trinidad and Tobago',
    value: 'TTO',
  },
  {
    label: 'Tunisia',
    value: 'TUN',
  },
  {
    label: 'Turkey',
    value: 'TUR',
  },
  {
    label: 'Turkmenistan',
    value: 'TKM',
  },
  {
    label: 'Turks and Caicos Islands',
    value: 'TCA',
  },
  {
    label: 'Tuvalu',
    value: 'TUV',
  },
  {
    label: 'Uganda',
    value: 'UGA',
  },
  {
    label: 'Ukraine',
    value: 'UKR',
  },
  {
    label: 'United Arab Emirates',
    value: 'ARE',
  },
  {
    label: 'United Kingdom',
    value: 'GBR',
  },
  {
    label: 'Uruguay',
    value: 'URY',
  },
  {
    label: 'Uzbekistan',
    value: 'UZB',
  },
  {
    label: 'Vanuatu',
    value: 'VUT',
  },
  {
    label: 'Venezuela',
    value: 'VEN',
  },
  {
    label: 'Vietnam',
    value: 'VNM',
  },
  {
    label: 'Wallis and Futuna',
    value: 'WLF',
  },
  {
    label: 'Western Sahara',
    value: 'ESH',
  },
  {
    label: 'Yemen',
    value: 'YEM',
  },
  {
    label: 'Zambia',
    value: 'ZMB',
  },
  {
    label: 'Zimbabwe',
    value: 'ZWE',
  },
];

export const countriesGroup1 = ['AUT', 'BEL', 'CHE', 'DEU', 'FRA', 'GBR', 'NLD', 'NOR'];

export enum CountryNameCodeEnum {
  'Australia' = 'AUS',
  'New Zealand' = 'NZL',
  'United States of America' = 'USA',
  'China' = 'CHN',
  'Afghanistan' = 'AFG',
  'Aland Islands' = 'ALA',
  'Albania' = 'ALB',
  'Algeria' = 'DZA',
  'American Samoa' = 'ASM',
  'Andorra' = 'AND',
  'Angola' = 'AGO',
  'Anguilla' = 'AIA',
  'Antarctica' = 'ATA',
  'Antigua and Barbuda' = 'ATG',
  'Argentina' = 'ARG',
  'Armenia' = 'ARM',
  'Aruba' = 'ABW',
  'Austria' = 'AUT',
  'Azerbaijan' = 'AZE',
  'Bahamas' = 'BHS',
  'Bahrain' = 'BHR',
  'Bangladesh' = 'BGD',
  'Barbados' = 'BRB',
  'Belarus' = 'BLR',
  'Belgium' = 'BEL',
  'Belize' = 'BLZ',
  'Benin' = 'BEN',
  'Bermuda' = 'BMU',
  'Bhutan' = 'BTN',
  'Bolivia' = 'BOL',
  'Bonaire, Sint Eustatius and Saba' = 'BES',
  'Bosnia and Herzegovina' = 'BIH',
  'Botswana' = 'BWA',
  'Bouvet Island' = 'BVT',
  'Brazil' = 'BRA',
  'British Indian Ocean Territory' = 'IOT',
  'United States Minor Outlying Islands' = 'UMI',
  'Virgin Islands (British)' = 'VGB',
  'Virgin Islands (U.S.)' = 'VIR',
  'Brunei Darussalam' = 'BRN',
  'Bulgaria' = 'BGR',
  'Burkina Faso' = 'BFA',
  'Burundi' = 'BDI',
  'Cambodia' = 'KHM',
  'Cameroon' = 'CMR',
  'Canada' = 'CAN',
  'Cabo Verde' = 'CPV',
  'Cayman Islands' = 'CYM',
  'Central African Republic' = 'CAF',
  'Chad' = 'TCD',
  'Chile' = 'CHL',
  'Christmas Island' = 'CXR',
  'Keeling Islands' = 'CCK',
  'Colombia' = 'COL',
  'Comoros' = 'COM',
  'Congo, Democratic Republic of the' = 'COD',
  'Congo, Republic of the' = 'COG',
  'Cook Islands' = 'COK',
  'Costa Rica' = 'CRI',
  "Cote d'Ivoire" = 'CIV',
  'Croatia' = 'HRV',
  'Cuba' = 'CUB',
  'Curacao' = 'CUW',
  'Cyprus' = 'CYP',
  'Czech Republic' = 'CZE',
  'Denmark' = 'DNK',
  'Djibouti' = 'DJI',
  'Dominica' = 'DMA',
  'Dominican Republic' = 'DOM',
  'Ecuador' = 'ECU',
  'Egypt' = 'EGY',
  'El Salvador' = 'SLV',
  'Equatorial Guinea' = 'GNQ',
  'Eritrea' = 'ERI',
  'Estonia' = 'EST',
  'Ethiopia' = 'ETH',
  'Falkland Islands (Malvinas)' = 'FLK',
  'Faroe Islands' = 'FRO',
  'Fiji' = 'FJI',
  'Finland' = 'FIN',
  'France' = 'FRA',
  'French Guiana' = 'GUF',
  'French Polynesia' = 'PYF',
  'French Southern Territories' = 'ATF',
  'Gabon' = 'GAB',
  'Gambia' = 'GMB',
  'Georgia' = 'GEO',
  'Germany' = 'DEU',
  'Ghana' = 'GHA',
  'Gibraltar' = 'GIB',
  'Greece' = 'GRC',
  'Greenland' = 'GRL',
  'Grenada' = 'GRD',
  'Guadeloupe' = 'GLP',
  'Guam' = 'GUM',
  'Guatemala' = 'GTM',
  'Guernsey' = 'GGY',
  'Guinea' = 'GIN',
  'Guinea-Bissau' = 'GNB',
  'Guyana' = 'GUY',
  'Haiti' = 'HTI',
  'Heard Island and McDonald Islands' = 'HMD',
  'Holy See (Vatican City State)' = 'VAT',
  'Honduras' = 'HND',
  'Hong Kong' = 'HKG',
  'Hungary' = 'HUN',
  'Iceland' = 'ISL',
  'India' = 'IND',
  'Indonesia' = 'IDN',
  'Iran (Islamic Republic of)' = 'IRN',
  'Iraq' = 'IRQ',
  'Ireland' = 'IRL',
  'Isle of Man' = 'IMN',
  'Israel' = 'ISR',
  'Italy' = 'ITA',
  'Jamaica' = 'JAM',
  'Japan' = 'JPN',
  'Jersey' = 'JEY',
  'Jordan' = 'JOR',
  'Kazakhstan' = 'KAZ',
  'Kenya' = 'KEN',
  'Kiribati' = 'KIR',
  'Kuwait' = 'KWT',
  'Kyrgyzstan' = 'KGZ',
  "Lao People's Democratic Republic" = 'LAO',
  'Latvia' = 'LVA',
  'Lebanon' = 'LBN',
  'Lesotho' = 'LSO',
  'Liberia' = 'LBR',
  'Libya' = 'LBY',
  'Liechtenstein' = 'LIE',
  'Lithuania' = 'LTU',
  'Luxembourg' = 'LUX',
  'Macao' = 'MAC',
  'Macedonia (the former Yugoslav Republic of)' = 'MKD',
  'Madagascar' = 'MDG',
  'Malawi' = 'MWI',
  'Malaysia' = 'MYS',
  'Maldives' = 'MDV',
  'Mali' = 'MLI',
  'Malta' = 'MLT',
  'Marshall Islands' = 'MHL',
  'Martinique' = 'MTQ',
  'Mauritania' = 'MRT',
  'Mauritius' = 'MUS',
  'Mayotte' = 'MYT',
  'Mexico' = 'MEX',
  'Micronesia (Federated States of)' = 'FSM',
  'Moldova (Republic of)' = 'MDA',
  'Monaco' = 'MCO',
  'Mongolia' = 'MNG',
  'Montenegro' = 'MNE',
  'Montserrat' = 'MSR',
  'Morocco' = 'MAR',
  'Mozambique' = 'MOZ',
  'Myanmar' = 'MMR',
  'Namibia' = 'NAM',
  'Nauru' = 'NRU',
  'Nepal' = 'NPL',
  'Netherlands' = 'NLD',
  'New Caledonia' = 'NCL',
  'Nicaragua' = 'NIC',
  'Niger' = 'NER',
  'Nigeria' = 'NGA',
  'Niue' = 'NIU',
  'Norfolk Island' = 'NFK',
  'North Korea' = 'PRK',
  'Northern Mariana Islands' = 'MNP',
  'Norway' = 'NOR',
  'Oman' = 'OMN',
  'Pakistan' = 'PAK',
  'Palau' = 'PLW',
  'Palestine, State of' = 'PSE',
  'Panama' = 'PAN',
  'Papua New Guinea' = 'PNG',
  'Paraguay' = 'PRY',
  'Peru' = 'PER',
  'Philippines' = 'PHL',
  'Pitcairn' = 'PCN',
  'Poland' = 'POL',
  'Portugal' = 'PRT',
  'Puerto Rico' = 'PRI',
  'Qatar' = 'QAT',
  'Republic of Korea' = 'KOR',
  'Romania' = 'ROU',
  'Russian Federation' = 'RUS',
  'Rwanda' = 'RWA',
  'Saint Barthelemy' = 'BLM',
  'Saint Helena, Ascension and Tristan da Cunha' = 'SHN',
  'Saint Kitts and Nevis' = 'KNA',
  'Saint Lucia' = 'LCA',
  'Saint Martin (French part)' = 'MAF',
  'Saint Pierre and Miquelon' = 'SPM',
  'Saint Vincent and the Grenadines' = 'VCT',
  'Samoa' = 'WSM',
  'San Marino' = 'SMR',
  'Sao Tome and Principe' = 'STP',
  'Saudi Arabia' = 'SAU',
  'Senegal' = 'SEN',
  'Serbia' = 'SRB',
  'Seychelles' = 'SYC',
  'Sierra Leone' = 'SLE',
  'Singapore' = 'SGP',
  'Sint Maarten (Dutch part)' = 'SXM',
  'Slovakia' = 'SVK',
  'Slovenia' = 'SVN',
  'Solomon Islands' = 'SLB',
  'Somalia' = 'SOM',
  'South Africa' = 'ZAF',
  'South Georgia and the South Sandwich Islands' = 'SGS',
  'South Sudan' = 'SSD',
  'Spain' = 'ESP',
  'Sri Lanka' = 'LKA',
  'Sudan' = 'SDN',
  'Suriname' = 'SUR',
  'Svalbard and Jan Mayen' = 'SJM',
  'Swaziland' = 'SWZ',
  'Sweden' = 'SWE',
  'Switzerland' = 'CHE',
  'Syrian Arab Republic' = 'SYR',
  'Taiwan, Province of China' = 'TWN',
  'Tajikistan' = 'TJK',
  'Tanzania, United Republic of' = 'TZA',
  'Thailand' = 'THA',
  'Timor-Leste' = 'TLS',
  'Togo' = 'TGO',
  'Tokelau' = 'TKL',
  'Tonga' = 'TON',
  'Trinidad and Tobago' = 'TTO',
  'Tunisia' = 'TUN',
  'Turkey' = 'TUR',
  'Turkmenistan' = 'TKM',
  'Turks and Caicos Islands' = 'TCA',
  'Tuvalu' = 'TUV',
  'Uganda' = 'UGA',
  'Ukraine' = 'UKR',
  'United Arab Emirates' = 'ARE',
  'United Kingdom of Great Britain and Northern Ireland' = 'GBR',
  'Uruguay' = 'URY',
  'Uzbekistan' = 'UZB',
  'Vanuatu' = 'VUT',
  'Venezuela (Bolivarian Republic of)' = 'VEN',
  'Viet Nam' = 'VNM',
  'Wallis and Futuna' = 'WLF',
  'Western Sahara' = 'ESH',
  'Yemen' = 'YEM',
  'Zambia' = 'ZMB',
  'Zimbabwe' = 'ZWE',
}
